export default {
  data() {
    return {
      dropdownOpen: false,
    };
  },
  computed: {
    getIsDropdownOpened() {
      return this.dropdownOpen;
    },
  },
  methods: {
    toggleDropdownOpen() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    openDropdown() {
      this.dropdownOpen = true;
    },
  },
};
